import * as types from './types';

export const addFlashMessage = (message, msgType = 'error', statusCode) => ({
    type: types.ADD_FLASH_MESSAGE,
    msgType,
    message,
    statusCode,
});

export const clearFlashMessage = () => ({
    type: types.CLEAR_FLASH_MESSAGE,
});